
define('text!modules/feedback/directives/user-profile-cta/templates/my-preparation-init.html',[],function () { return '<a class=btn__me ng-class="{ btn__small : isSmall, btn__big : isBig }" ng-click=UserProfileCtaCtrl.closeTasks() ui-sref=app.me.myPerformance.prepare.wizard><span translate=MY_PERFORMANCE.PREPARATION_INIT.CTA></span></a>';});

